/**
 * CommandParser - JSON-basedコマンドをパースする
 *
 * 構文: x:<command> {JSON}
 * 例: x:tab {"type":"sql-editor","title":"Test"}
 */

import type { ParseResult } from './types';

const COMMAND_PREFIX = 'x:';

/**
 * 入力がコマンドモードかどうかを判定
 */
export function isCommandMode(input: string): boolean {
  return input.trim().startsWith(COMMAND_PREFIX);
}

/**
 * コマンド文字列をパース
 */
export function parseCommand(input: string): ParseResult {
  const trimmed = input.trim();

  if (!trimmed.startsWith(COMMAND_PREFIX)) {
    return { success: false, error: 'Command must start with "x:"' };
  }

  const rest = trimmed.slice(COMMAND_PREFIX.length).trim();

  if (!rest) {
    return { success: false, error: 'Empty command' };
  }

  // コマンド名とJSON部分を分離
  const spaceIndex = rest.indexOf(' ');

  if (spaceIndex === -1) {
    // コマンド名のみ（JSONなし）
    return {
      success: true,
      command: {
        name: rest.toLowerCase(),
        rawInput: input,
        positionalArgs: [],
        namedArgs: {},
        flags: new Set()
      }
    };
  }

  const name = rest.slice(0, spaceIndex).toLowerCase();
  const jsonStr = rest.slice(spaceIndex + 1).trim();

  return {
    success: true,
    command: {
      name,
      rawInput: input,
      positionalArgs: jsonStr ? [jsonStr] : [],
      namedArgs: {},
      flags: new Set()
    }
  };
}
